import { EventEmitter} from '@angular/core';
import { Component, Output, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FaqCategoryDto } from '@feature/_app_modules/responsive-faq/faq.types';
import * as lodash from 'lodash';
import { FaqCategoryFormsService } from '../services/faq-category-forms.service';

@Component({
    selector: 'faq-category-dialog',
    templateUrl: './faq-category-dialog.component.html'
})

export class FaqCategoryDialogComponent implements OnInit {

    @Input() faqCategories: FaqCategoryDto[];
    dialogOpen = false;
    dialogTitle: string;
    form: FormGroup;
    category: FaqCategoryDto;
    @Output() onSave = new EventEmitter<FaqCategoryDto>();

    constructor(private faqCategoryFormService: FaqCategoryFormsService){
    }

    ngOnInit(): void {
        this.form = this.faqCategoryFormService.buildForm(this.faqCategories);
    }

    /**
     * Builds add new faq category dialog
     */
    showAddNewFaqCategoryDialog(){
        this.dialogTitle = "Add New Subject";
        this.category = {
                    Id: undefined,
                    Title: '',
                    Order: undefined,
                    IsGeneralEnquiry: false
                }
        this.form = this.faqCategoryFormService.buildForm(this.faqCategories);
        this.dialogOpen = true;
    }

    /**
     * Builds edit faq category dialog
     * @param category 
     */
    showEditFaqCategoryDialog(category: FaqCategoryDto){
        this.dialogTitle = "Edit Subject";
        this.category = lodash.clone(category);
        this.form = this.faqCategoryFormService.buildForm(this.faqCategories);
        this.faqCategoryFormService.mapCategoryToForm(this.form, category)
        this.dialogOpen = true;
    }

    /**
     * Handles cancel dialog button clicked
     */
    cancel(){
        this.dialogOpen = false;
    }

    /**
     * Handles save dialog button clicked
     */
    save(){
        this.faqCategoryFormService.mapFormToCategory(this.form, this.category);
        this.onSave.emit(this.category);
        this.dialogOpen = false;
    }
}